import { render, staticRenderFns } from "./OutputAcknowledgement.vue?vue&type=template&id=08c31c73&scoped=true"
import script from "./OutputAcknowledgement.vue?vue&type=script&lang=js"
export * from "./OutputAcknowledgement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c31c73",
  null
  
)

export default component.exports